import { CalendarService } from '../../_services/calendar.service';
import { Component, OnInit, AfterViewInit, Input, } from '@angular/core';
import { environment } from '../../../../src/environments/environment';
import { SolrService } from '../solr.service';
import { AuthenticationService, MenuService } from '../../_services';
import { TranslateService } from '@ngx-translate/core';
import { ElementService } from '../../_services/element.service';
import { CommonModule } from '@angular/common';

declare const initDataRange: any

@Component({
  standalone:true,
  selector: 'app-calendar-filter',
  templateUrl: './calendar-filter.component.html',
  styleUrls: ['./calendar-filter.component.scss'],
  imports: [CommonModule]
})
export class CalendarFilterComponent implements OnInit {
  showFilter = true;
  @Input() field: string = '';
  @Input() empresaId: string = '';
  @Input() calendarId: string = '';
  constructor(
    private solrService: SolrService,
    private calendarService: CalendarService,
    private authService: AuthenticationService,
    private menuService: MenuService,
    public translate: TranslateService,
    public elementService: ElementService
  ) {
    let storelang = localStorage.getItem("lang") || 'pt';
    this.translate.use(storelang);
  }

  ngOnInit() {
    this.menuService.getCurrent().subscribe((links: any) => {
      if (links && links.length > 0) {
        const lastLink = links.slice(-1)[0];
        this.empresaId = lastLink?.empresaId;
        this.field = lastLink?.field;
        this.callDataRange();
      }
    })
  }
  

  applyFilterDataRange(start: any, end: any, self: any) {
    // console.log(new Date(start))
    // console.log(new Date(end))
    const startDate = self.calendarService.formatDate(start);
    const endDate = self.calendarService.formatDate(end);
    self.calendarService.setCalendarRange({ start: startDate, end: endDate })
  }

  callDataRange() {

    var dateOld = '';
    if(!this.field) {
      this.field = 'creation_date'
    }
    if(!this.empresaId) {
      this.empresaId = this.authService.currentUserValue?.selectedEmpresa?._id || '';
    }

    this.solrService.getDateOld(environment.solr.url, 'docs-ia', this.field, this.empresaId).subscribe((data: any) => {
      if(data?.response?.docs?.length == 1) {
        const docField = data.response.docs[0]?.[this.field];
        if (docField) {
          dateOld = docField.split('T')[0];
        }
      }
      initDataRange(this.applyFilterDataRange, this, this.solrService, 'calendario', dateOld);
    });

    // initDataRange(this.applyFilterDataRange, this, "relatorio");
  }

}
